import React from 'react';
import { Link } from 'react-router-dom';
const LinkEditar = ({ to }) => {
    return (
        <Link to={to}>
            <i className="cui-note icons font-2xl "></i>
        </Link>
    )
};
export default LinkEditar